import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ListingService } from '../listing.service';

@Component({
 selector: 'app-attendees-report',
 templateUrl: './attendees-report.component.html',
 styleUrls: ['./attendees-report.component.css', '../admin.css'],
 providers: [ListingService]
})

export class AttendeesReportComponent implements OnInit{

 public spinner: boolean = false;
 public attendees = [];

 constructor(private titleService: Title, private listingService: ListingService) { }

 ngOnInit(){
  this.titleService.setTitle('Attendees Report');
  if(localStorage.getItem('eventId'))
  this.getAttendeeList(localStorage.getItem('eventId'));
 }

 getAttendeeList(eventId){
  this.spinner = true;
  this.listingService.getAttendeeList({eventId:eventId}).subscribe(
   response => {
    this.spinner = false;
    this.attendees = response.attendeeList;
    print();
   },
   error => {
    this.spinner = false;
   }
  );
 }
}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/attendees-report/attendees-report.component.ts